export enum VaccinationStatusEnum {
	ABANDONED = "abandoned",
	PENDING = "pending",
	DELAYED = "delayed",
	FINISHED = "finished",
	LOST = "lost",
}

export const VaccinationStatusMessage = {
	[VaccinationStatusEnum.ABANDONED]: "Abandonado",
	[VaccinationStatusEnum.PENDING]: "Pendente",
	[VaccinationStatusEnum.DELAYED]: "Em atraso",
	[VaccinationStatusEnum.FINISHED]: "Finalizado",
	[VaccinationStatusEnum.LOST]: "Perdido",
};
